// extracted by mini-css-extract-plugin
export var divider = "Footer-module--divider--85273";
export var download_section = "Footer-module--download_section--9f936";
export var flex_auto = "Footer-module--flex_auto--5b14c";
export var footer = "Footer-module--footer--2d913";
export var footer_col = "Footer-module--footer_col--5438b";
export var footer_container = "Footer-module--footer_container--4e187";
export var footer_copyright = "Footer-module--footer_copyright--0c4e1";
export var footer_items = "Footer-module--footer_items--da9af";
export var icons_row = "Footer-module--icons_row--4f1c6";
export var select_container = "Footer-module--select_container--aeac2";